import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  ViewChild,
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { Button } from 'primeng/button';
import { Popover } from 'primeng/popover';
import { HelpAndDocumentationContainerComponent } from '../help-and-documentation-container/help-and-documentation-container.component';
import { EventType, Router } from '@angular/router';
import { filter, tap } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { HelpAndDocumentationService } from '../help-and-documentation.service';

import { HelpButtonPositionerService } from '../help-button-positioner.service';

@Component({
  selector: 'app-help-and-documentation-trigger',
  imports: [
    TranslatePipe,
    Button,
    Popover,
    HelpAndDocumentationContainerComponent,
  ],
  templateUrl: './help-and-documentation-button.component.html',
  styleUrl: './help-and-documentation-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HelpAndDocumentationButtonComponent implements AfterViewInit {
  readonly helpAndDocumentationService = inject(HelpAndDocumentationService);
  readonly helpButtonPositionerService = inject(HelpButtonPositionerService);
  readonly router = inject(Router);
  readonly destroyRef = inject(DestroyRef);

  @ViewChild('helpContainer')
  popover: Popover;

  ngAfterViewInit() {
    this.router.events
      .pipe(filter((e) => e.type === EventType.ActivationEnd))
      .pipe(
        tap(() => this.popover.hide()),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe();
  }
}
